export const WEWORK_UNLIMITED_ADDON_ID = "wework-unlimited-access";

// Anchor a stricter match than includes("all-access") so partner-authored
// links like /blog/all-access-vs-coworking don't falsely emit the WeWork
// Israel unlimited_access_click event.
export function isWeworkAllAccessUrl(href: string): boolean {
  if (!href) return false;
  try {
    const u = new URL(href, window.location.href);
    return (
      u.hostname.endsWith("wework.co.il") &&
      u.pathname.endsWith("/solutions/all-access")
    );
  } catch {
    return false;
  }
}

// Locale-specific WeWork Israel All Access upsell URL.
export function weworkAllAccessUrl(baseLanguageTag: string): string {
  return baseLanguageTag === "he"
    ? "https://www.wework.co.il/solutions/all-access"
    : "https://www.wework.co.il/en/solutions/all-access";
}
